import React from 'react';
import Biomercylogo from '../../assets/images/logoFooter.png';
import './Footer.css';

const FooterBioMercy = () => {
  return (
    <footer className="footer-gray">
      <div className="footer-content">
        <div className="footer-left">
          <img
            src={Biomercylogo}
            loading="lazy"
            alt="Logo BioMercy"
            className="footer-logo-img"
          />
          <div className="footer-slogan-wrapper">
            <h4 className="footer-slogan">Innovamos con propósito</h4>
            <p className="footer-subtext">
              Comprometidos con la salud y<br />
              el bienestar de todos los venezolanos.
            </p>
          </div>
        </div>
        <div className="footer-right">
          <h3 className="footer-title">Contactos</h3>
          <h6 className="contact-label">CORREO ELECTRÓNICO</h6>
          <p className="contact-text">info@groupbiomercy.com</p>
          <p className="contact-text long-email">
            coor.comyeventos@groupbiomercy.com
          </p>
          <h6 className="contact-label">TELÉFONO</h6>
          <p className="contact-text">+58 424-1727885</p>
          <p className="contact-text">+58 412-7095725</p>
        </div>
      </div>
      <p className="footer-copy">
        © 2025 Corporación Médica Los Llanos CA. RIF: J-31578680-0
      </p>
    </footer>
  );
};

export default FooterBioMercy;
